import { Event, Globe } from "@gigpro/ui/Icons";
import { employmentTypeSchema } from "api/resources/shared";
import type { Filters } from "domains/schedule/components/Filters";
import { boolean, date, number, route, string } from "react-router-typesafe-routes";
import { zod } from "react-router-typesafe-routes/zod";

export const sortOptions = [
  { id: "start_time", name: "Starting Soonest" },
  { id: "-start_time", name: "Starting Latest" },
  { id: "-created_ts", name: "Last Posted" },
  { id: "-last_updated_ts", name: "Last Modified" },
] as const satisfies NonNullable<React.ComponentProps<typeof Filters>["sort"]>["options"];

export const gigStatusOptions = [
  {
    id: "unfilled",
    name: "Unfilled",
    controlClassName: "data-[state=checked]:border-gray data-[state=checked]:bg-gray",
  },
  {
    id: "ready",
    name: "Filled",
    controlClassName: "data-[state=checked]:border-info data-[state=checked]:bg-info",
  },
  {
    id: "completed",
    name: "Completed",
    controlClassName: "data-[state=checked]:border-success data-[state=checked]:bg-success",
  },
  {
    id: "paymentDue",
    name: "Payment Due",
    controlClassName: "data-[state=checked]:border-warning data-[state=checked]:bg-warning",
  },
  {
    id: "paymentError",
    name: "Payment Error",
    controlClassName: "data-[state=checked]:border-error data-[state=checked]:bg-error",
  },
  {
    id: "cancelled",
    name: "Cancelled",
    controlClassName: "data-[state=checked]:border-medium-gray data-[state=checked]:bg-medium-gray",
  },
] as const satisfies React.ComponentProps<typeof Filters>["gigStatus"]["options"];
export type GigStatusFilterOptions = (typeof gigStatusOptions)[number];
export const gigStatusOptionIds = gigStatusOptions.map(({ id }) => id);

export const gigTypeOptions = [
  {
    id: "marketplace",
    name: "Marketplace",
  },
  {
    id: "network",
    name: "Network",
    icon: Globe,
  },
] as const satisfies NonNullable<React.ComponentProps<typeof Filters>["gigType"]>["options"];
export type GigTypeFilterOptions = (typeof gigTypeOptions)[number];
export const gigTypeOptionIds = gigTypeOptions.map(({ id }) => id);

export const eventsOptions = [
  { id: "gigs", name: "Shifts" },
  { id: "events", name: "Events", icon: Event },
] as const satisfies NonNullable<React.ComponentProps<typeof Filters>["events"]>["options"];
const eventsOptionIds = eventsOptions.map(({ id }) => id);
export type EventsFilterOptions = (typeof eventsOptionIds)[number];

export type GigFilterRouteParams = ReturnType<typeof gigFilterRouteParams.$deserializeSearchParams>;
export const gigFilterRouteParams = route({
  searchParams: {
    ordering: string(),

    // admin filters
    require_certifications: boolean(),
    elevated: boolean(),
    auto_select_enabled: boolean(),
    location_name: string(),
    market_name: string(),
    skill_id: number(),
    pro_id: number(),
    pro_first_name: string(),
    pro_last_name: string(),
    start_time__gte: date(),
    start_time__lte: date(),
    end_time__gte: date(),
    end_time__lte: date(),
    employment_type: zod(employmentTypeSchema),
    gig_id: number(),
  },
});
